.error-page{font-size:50px;width:100%;line-height:50px;text-align:center;margin-top:60px;color:#ff000059}
/*# sourceMappingURL=/ba/public/error-page.component.css.map */
